import { render, staticRenderFns } from "./iristarSolution.vue?vue&type=template&id=024285d1&"
import script from "./iristarSolution.vue?vue&type=script&lang=js&"
export * from "./iristarSolution.vue?vue&type=script&lang=js&"
import style0 from "./iristarSolution.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports